import { ConvertDate } from "../../Base/helper/baseFunctions";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import menu from "../Images/menu.png"
import footerlogoSrc from "../../Finance/images/Meepl_new_logo with text png.png";
const styles = StyleSheet.create({
  page: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingHorizontal: 24,
    fontFamily: "Helvetica",
    fontSize: 10,
    justifyContent: "flex-start",
    alignItems: "center",
  },
  card: {
    width: 230,
    minHeight: 320,
    borderWidth: 1,
    borderColor: "#e5e7eb",
    borderRadius: 8,
    paddingVertical: 18,
    paddingHorizontal: 16,
    alignItems: "center",
  },
  logoWrapper: {
    width: 80,
    height: 70,
    marginBottom: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: 60,
    height: 60,
  },
  mealTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 6,
    textAlign: "center",
  },
  tokenCode: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 18,
    textAlign: "center",
  },
  row: {
    width: "100%",
    flexDirection: "row",
    marginBottom: 6,
    flexWrap: "wrap",
  },
  label: {
    width: 70,
    fontWeight: "bold",
  },
  separator: {
    width: 8,
    textAlign: "center",
  },
  value: {
    flex: 1,
    flexShrink: 1, 
    flexWrap: "wrap",      
    wordBreak: "break-word",
  },
  spacer: {
    marginTop: 20,
  },
  headerContainer: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 4,
  },

  logoWrapperTop: {
    width: 80,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 4,

  },

  logoTop: {
    width: 60,
    height: 60,
    objectFit: "contain",
  },

  companyNameTop: {
    fontSize: 16,
    fontWeight: 800,
    textAlign: "center",
    color: "#000",
  },
  footerPowered: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: "5px"
  },
  footerLogo: {
      height: 15,
      objectFit: "contain",
      marginLeft: 5,
  },
});

const TokenPdf = ({
  region= "",
  tokenCode = "",
  employeeName = "",
  companyName = "",
  tokens="",
  imageUrl=""
}) => {
  return (
  <Document>
    {/* A7 = small page, good for token */}
    <Page size="A5" style={styles.page}>
      <View style={styles.card}>
        {imageUrl && (
          <View style={styles.headerContainer} fixed>
            {imageUrl ? (
              <View style={styles.logoWrapperTop}>
                <Image style={styles.logoTop} src={imageUrl} />
              </View>
            ) : null}
          </View>
        )}
        <Text style={styles.mealTitle}>Meal Token</Text>
        <Text style={{...styles.tokenCode, marginBottom: 4,}}>{companyName}</Text>
        {/* Logo */}
        <View style={styles.logoWrapper}>
            <Image
              src={menu}
              style={{ width: 36, height: 36, marginBottom: 4 }}
            />
        </View>

        {/* Token Code */}
        <Text style={styles.tokenCode}>{tokenCode}</Text>

        {/* Details */}
        <View style={styles.row}>
          <Text style={styles.label}>Employee</Text>
          <Text style={styles.separator}>:</Text>
          <Text style={styles.value}>{employeeName}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Region</Text>
          <Text style={styles.separator}>:</Text>
          <Text style={styles.value}>{region}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>Token Count</Text>
          <Text style={styles.separator}>:</Text>
          <Text style={styles.value}>{tokens}</Text>
        </View>

        <View style={styles.spacer} />

        {/* Footer */}
        <View style={styles.footerPowered}>
            <Text>Powered by</Text>
            <Image style={styles.footerLogo} src={footerlogoSrc} />
        </View>
      </View>
    </Page>
  </Document>
)};


function generateTokenContent(generatedToken) {
  return (
    <table
      width="100%"
      border="0"
      align="center"
      cellPadding="0"
      cellSpacing="0"
      style={{
        maxWidth: "1070px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.06)",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
      }}
    >
      <tbody>
        <tr style={{ textAlign: "left" }}>
          <td style={{ padding: "20px 45px 0" }}>
            <span
              style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
            >
              Hi {generatedToken.employee_name},
            </span>
          </td>
        </tr>

        <tr>
          <td style={{ height: "20px" }}>&nbsp;</td>
        </tr>
        <tr>
          <td style={{ padding: "0px 45px", textAlign: "start" }}>
            <span
              style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
            >
              Here are your meal token details:
            </span>
          </td>
        </tr>
         <tr>
          <td style={{ height: "12px" }}>&nbsp;</td>
        </tr>

        {/* Aligned Data Table */}
        <tr>
          <td style={{ padding: "0px 45px 20px" }}>
            <table width="100%" cellPadding="0" cellSpacing="0">
              <tbody>
                {[
                  ["Company", generatedToken.company || ""],
                  ["Name", generatedToken.employee_name || ""],
                  ["Token Id", generatedToken.uuid || ""],
                  ["Token Count", generatedToken.tokens || "-"],
                  ["Issued", ConvertDate(generatedToken.issued) || "-"],
                  ["Token Balance", generatedToken.token_balance || "-"],
                ].map(([label, value], i) => (
                  <tr key={i}>
                    <td
                      width="160"
                      style={{
                        color: "#455056",
                        fontSize: "15px",
                        lineHeight: "26px",
                        fontWeight: 600,
                        verticalAlign: "top",
                        textAlign: "start" 
                      }}
                    >
                      {label}
                    </td>
                    <td
                      style={{
                        color: "#455056",
                        fontSize: "15px",
                        lineHeight: "26px",
                        textAlign: "start" 
                      }}
                    >
                      :&nbsp;{value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

function assignTokenContent({ generatedToken }) {
  return (
    <table
      width="100%"
      border="0"
      align="center"
      cellPadding="0"
      cellSpacing="0"
      style={{
        maxWidth: "1070px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.06)",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
      }}
    >
      <tbody>
        <tr style={{ textAlign: "left" }}>
          <td style={{ padding: "20px 45px 0" }}>
            <span
              style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
            >
              Hi {generatedToken.employee_name},
            </span>
          </td>
        </tr>

        <tr>
          <td style={{ height: "20px" }}>&nbsp;</td>
        </tr>
        <tr>
          <td style={{ padding: "0px 45px", textAlign: "start" }}>
            <span
              style={{ color: "#455056", fontSize: "15px", lineHeight: "24px" }}
            >
              Here are your meal token assigned details:
            </span>
          </td>
        </tr>
         <tr>
          <td style={{ height: "12px" }}>&nbsp;</td>
        </tr>

        {/* Aligned Data Table */}
        <tr>
          <td style={{ padding: "0px 45px 20px" }}>
            <table width="100%" cellPadding="0" cellSpacing="0">
              <tbody>
                {[
                  ["Company", generatedToken.company || ""],
                  ["Name", generatedToken.employee_name || ""],
                  ["Token Id", generatedToken.uuid || ""],
                  ["Total Token Count", generatedToken.tokens || "-"],
                  ["Issued", ConvertDate(generatedToken.issued) || "-"],
                  
                ].map(([label, value], i) => (
                  <tr key={i}>
                    <td
                      width="160"
                      style={{
                        color: "#455056",
                        fontSize: "15px",
                        lineHeight: "26px",
                        fontWeight: 600,
                        verticalAlign: "top",
                        textAlign: "start" 
                      }}
                    >
                      {label}
                    </td>
                    <td
                      style={{
                        color: "#455056",
                        fontSize: "15px",
                        lineHeight: "26px",
                        textAlign: "start" 
                      }}
                    >
                      :&nbsp;{value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export { generateTokenContent, assignTokenContent, TokenPdf};
